module.exports = __webpack_public_path__ + "static/img/jobAi.73730739.png";